import { i18n } from "@v2/shared/config";
export function enumerateDaysBetweenDates(startDate, endDate) {
  const now = startDate.clone();
  const dates = [];

  while (now.isSameOrBefore(endDate)) {
    dates.push(now.format("YYYY-MM-DD"));
    now.add(1, "days");
  }

  return dates;
}

export const fileLogoValidate = file => {
  if (file.size > 2097152) throw "event.companyProfile.modal.logoSize"; // if more than 2Mb (size in bytes)
};

export const getLocaleValue = (info, field) => {
  const data =
    info?.location?.features?.find(item => item.name === field) || null;
  return i18n.locale === "ru" && data
    ? data.value_ru
    : i18n.locale === "en" && data
    ? data.value_en
    : "";
};
